import { useState } from 'react'
import { getImageUrlFromName } from '../../../util'
// import ReactReadMoreReadLess from 'react-read-more-read-less'
import ReactMoreReadLess from '../../common/ReadMoreReadLess/ReactMoreReadLess'
import ViewAll from '../ViewAll'
import ExpandDetail from './ExpandDetail'

const TextLayout = ({ layout, value, handleDetailPageClose }) => {
  // what you'll do and additional info
  // console.log('>>>>>value text', value.text)
  // dialogues box
  const [open, setOpen] = useState(false)

  const handleExpandPageOpen = () => {
    setOpen(true)
  }

  const handleExpandPageClose = () => {
    setOpen(false)
  }
  //----
  let imageUrl = getImageUrlFromName(layout.icon_name)
  return (
    <div>
      {value && (
        <div
          style={{
            padding: '32px 20px 32px 20px',
            background: layout.color ? `#${layout.color}` : '',
            // background: '#ff0000',
          }}
        >
          <div>
            <img src={imageUrl} style={{ width: '100px', height: 'auto' }} />
          </div>
          <div
            style={{
              marginTop: '16px',
              marginBottom: '24px',
              textAlign: 'left',
              color: 'var(--gray100)',
              listStyle: 'none',
            }}
          >
            <p className="headline1">{layout.display_name}</p>
          </div>
          <div
            style={{
              textAlign: 'left',
              color: 'var(--gray80)',
            }}
          >
            <pre
              className="body2"
              style={{
                whiteSpace: 'pre-line',
                lineHeight: '150%',
                wordWrap: 'break-word',
              }}
            >
              <ReactMoreReadLess
                moreText={'See all'}
                lessText={'See few'}
                showArrow={true}
                lines={layout.display_name === "What you'll do" ? '8' : '5'}
                top={'24px'}
                isExpand={true}
                handlerFunction={handleExpandPageOpen}
                isCustomIcon={true}
              >
                {value.text ? value.text : value[0]}
              </ReactMoreReadLess>
              {/* <ViewAll>See all</ViewAll> */}
            </pre>
          </div>
        </div>
      )}
      <ExpandDetail
        open={open}
        handleExpandPageClose={handleExpandPageClose}
        handleDetailPageClose={handleDetailPageClose}
        value={value}
        layout={layout}
        contentType={layout.display_name}
      />
    </div>
  )
}
export default TextLayout
